import { render } from "./NftTokenHolder.vue?vue&type=template&id=71beffa8"
import script from "./NftTokenHolder.vue?vue&type=script&lang=js"
export * from "./NftTokenHolder.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/testnet.onegate/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__